
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// realisations
import { ManagerT } from '@/core/types/users.types'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        Modal,
        FileReader,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'managers'],
    setup(props, { emit }) {
        const state = reactive({
            file: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const data_state = reactive({
            managers: new DataState<ManagerT>({}),
        })

        const emitCancel = () => {
            emit('cancel')
        }

        const emitManagers = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid || props.loading) return

            const form_data = new FormData()
            form_data.append('file', state.file[0])

            emit('managers', form_data)
        }

        return {
            state,
            data_state,
            //
            state_form$,
            //
            emitCancel,
            emitManagers,
        }
    },
})
